import api, { handleAPIErrors  } from 'shared/api'

const FETCH_REQUEST = 'superannuations/FETCH_REQUEST'
const FETCH_SUCCESS = 'superannuations/FETCH_SUCCESS'
const FETCH_SUPERANNUATION_SUCCESS = 'superannuations/FETCH_SUPERANNUATION_SUCCESS'
const FETCH_FAILURE = 'superannuations/FETCH_FAILURE'

const FETCH_REPORT_REQUEST = 'privateCompanies/FETCH_REPORT_REQUEST'
const FETCH_COMPANY_REPORT_SUCCESS = 'privateCompanies/FETCH_COMPANY_REPORT_SUCCESS'
const FETCH_REPORT_FAILURE = 'privateCompanies/FETCH_REPORT_FAILURE'

const initialState = {
  superannuations: [],
  loadedSuperannuations: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  loadingReport: false,
  errors: [],
  reportData: {},
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchSuperannuationSuccess(payload) {
  return {
    type: FETCH_SUPERANNUATION_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchReportRequest(payload = {}) {
  return {
    type: FETCH_REPORT_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchReportSuccess(payload) {
  return {
    type: FETCH_COMPANY_REPORT_SUCCESS,
    payload,
  }
}

export function fetchReportFailure(errors = []) {
  return {
    type: FETCH_REPORT_FAILURE,
    errors,
  }
}

export function loadSuperannuation(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.superannuations.loadedIds ? state.superannuations.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`api/v1/superannuations/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuperannuationSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

export function loadSuperannuationReport(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.superannuations.loadedIds ? state.superannuations.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchReportRequest({ loadedIds }))

    return api(`api/v1/superannuations/${id}/report`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchReportSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchReportFailure(errors))
        })
      })
  }
}

export function loadSuperannuations(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api('api/v1/superannuations', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        superannuations: [...payload]
      })
    case FETCH_SUPERANNUATION_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedSuperannuations: [
          ...state.loadedSuperannuations,
          payload
        ]
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    case FETCH_REPORT_REQUEST:
      return Object.assign({}, state, {
        loadingReport: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_COMPANY_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loadingReport: false,
        errors: [],
        reportData: {
          ...payload
        },
      })
    case FETCH_REPORT_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loadingReport: false,
        errors,
      })
    default:
      return state
  }
}

